import React from "react";
import { Controls, IFormStyles, useFormStyles } from "..";

export const FormButton: React.FC<Controls.ControlButtonProps> = (props) => {
    const styles: IFormStyles = useFormStyles();

    return (
        <Controls.ControlButton {...props} controlStyles={styles.control} />
    );
};